export default "__VITE_ASSET__DtBpAw_M__"